import { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react';

export enum TagTape {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
}

export interface TypesProps extends DetailedHTMLProps<HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> {
  children: ReactNode;
  className?: string;
  tag: TagTape;
  color?: string;
  weight?: string;
}
